import { initFederation } from '@angular-architects/module-federation';
import { Environment } from './app/enums/environment.enum';
import { IEnvironment } from './app/interfaces/environment.interface';
import { EnvironmentService } from './app/services/environment.service';

const environmentService = new EnvironmentService().getInstance();

if(environmentService.getEnvironment() === Environment.Local){
    (window as any).ngDevMode = true;
}

((envConfig: IEnvironment[Environment]) => {
    const manifest = {};
    envConfig.manifest
        .filter(m => m.enabled)
        .forEach((m) => {
            manifest[m.name] = m.url;
        });
    initFederation(manifest)
    .catch(err => console.info(err))
    .then(_ => import('./bootstrap'))
    .catch(err => console.info(err));
})(environmentService.currentEnvironmentConfig); 